<style scoped>
.padding-top-10 {
  padding-top: 10px;
}
</style>

<template>
  <div class="full-height display-flex display-flex-column">
    <div class="flex-item" />
    <div class="full-width">
        <mu-row class="full-width">
          <mu-col span="3" />
          <mu-col span="6">
            <img :src="logo" class="full-width">
          </mu-col>
          <mu-col span="3" />
        </mu-row>
        <mu-row class="full-width padding-top-10">
          <mu-col span="3" />
          <mu-col span="6">
            <mu-flex class="flex-wrapper full-width" justify-content="center">
              <mu-button flat @click.prevent="onClickHKULogin" color="primary">
                <mu-icon left value="exit_to_app" />{{$t('login.sso')}}
              </mu-button>
            </mu-flex>
          </mu-col>
          <mu-col span="3" />
        </mu-row>
    </div>
    <div class="flex-item" />
  </div>
</template>

<script>
// Library
import axios from "axios";

// Assets

export default {
  name: "LoginPage",
  data: function() {
  return {
    // Model
    form: {},
  };
  },
  watch: {

  },
  computed: {

  // Flag
  isUsernameEmpty: function() {
    return this.modelUsername === "";
  },
  isPasswordEmpty: function() {
    return this.modelPassword === "";
  }
  },
  created() {
  if (!this.$store.getters.previewMode) this.$store.commit("previewMode");
  },
  methods: {
  // Event
  onActionLogin: function() {
    this.loading = true;
    axios.post(this.$store.getters.urlApi + "auth", {
      username: this.modelUsername,
      password: this.modelPassword,
      type: this.type
      }, {
      headers: {
        token: this.$store.state.auth.token,
        'content-type': 'application/json'
      },
      }
    ).then(response => {
      this.token = response.data.data.token;
      this.$store.commit("login", {
        token: response.data.data.token,
        user: response.data.data.user,
        path: this.$route.path
      });
      this.loading = false;
    }).catch(err => {
      this.loading = false;
      this.$toast.error(err.response.data.message);
    });
  },
  onClickHKULogin: function() {
    window.location.href =
    this.$store.getters.urlApi + "auth/cas?redirect=" + this.$route.path;
  }
  }
};
</script>
